import React from "react"

import lsLogo from "./livesession.inline.svg";
import {Container, Loading, Logo} from "./Loader.style"

export function Loader() {
    return null
}

export function SplashLoader() {
    return (
        <Container>
            <Logo src={lsLogo}/>
            <Loading>
                <div/>
            </Loading>
        </Container>
    )
}

SplashLoader.displayName = "SplashLoader"
